import { ConfigurationItemKind, } from "@plansoft-configuration-renderer/framework";
import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
const logger = new ConsoleLogger("NavigationState", LogLevels.warn);
export function findConfigurationItemParentsFromConfigurationObject(configurationObject, options) {
    const { attributePath, configurationObjectPath } = options;
    logger.debug("findConfigurationItemParentsFromConfigurationObject", configurationObject.path);
    if (!configurationObject.attributes) {
        return [];
    }
    for (const attribute of configurationObject.attributes) {
        if (attribute.path === attributePath) {
            return [
                {
                    kind: ConfigurationItemKind.ConfigurationAttribute,
                    id: attribute.id,
                    path: attributePath,
                },
            ];
        }
        if (attribute.configurations == null) {
            continue;
        }
        // TODO is it possible that there is a subconfiguration attribute that needs to be expanded?
        for (const subconfigurationObject of attribute.configurations) {
            if (configurationObjectPath.includes(subconfigurationObject.path)) {
                return [
                    {
                        kind: ConfigurationItemKind.ConfigurationObject,
                        id: subconfigurationObject.id,
                        path: subconfigurationObject.path,
                    },
                ];
            }
        }
    }
    return [];
}
//# sourceMappingURL=findConfigurationItemParentsFromConfigurationObject.js.map